import { mountApp } from '@dnai/agg-core-fe'
import { branding } from './branding.config'

// One build per client. The environment (dev vs prod backend, example ids) is
// chosen at container start via window.env — see public/env.js + entrypoint.sh.
// Client-specific branding/overrides are baked in here at build time.
mountApp({ config: branding })
